<template>
    <div>
        <div v-for="(item,index) in list" :key=index>
            <el-menu-item v-if="!item.children && !item.hidden" :index="headUrl+strUrl+item.path" @click.native="recordNavSub(headUrl+strUrl+item.path)" >
                <template slot="title">
                    <i :class="item.meta.icon"></i>
                    <span slot="title">{{item.meta.title}}</span>
                </template>
            </el-menu-item>
            <el-submenu  v-if="item.children && item.children.length" :index="headUrl+strUrl+item.path">
                <template slot="title">
                    <i :class="item.meta.icon"></i>
                    <span>{{item.meta.title}}</span>
                </template>
                <NavTree :list="item.children" :path="strUrl+item.path"></NavTree>
            </el-submenu>
        </div>
    </div>
</template>

<script>
export default {
    name:"NavTree",
    props:['list','path'],
    data() {
        return {
            headUrl: '/console/',
            strUrl: '',
        }
    },
    created() {
        //用于拼接url
        if (this.path) {
            this.strUrl += this.path + '/';
        }
    },
    methods: {
        recordNav(item){
            console.log(item);
        },
        recordNavSub(item){
            console.log(item)
            this.$router.replace(item);
        }
    }
}
</script>

<style scoped>

</style>